import React from 'react';
import { Redirect, RedirectProps } from 'react-router-dom';

const BasicRedirect = ({ to, ...props }: RedirectProps) => {
  const PUBLIC_PATH = process.env.PUBLIC_PATH || '';
  const basePath = PUBLIC_PATH && location.pathname.startsWith(PUBLIC_PATH) ? '' : PUBLIC_PATH;
  return <Redirect to={`${basePath}${to}`} {...props} />;
};

export default BasicRedirect;
